import { MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';

export const LockedIcon = MdOutlineVisibility;
export const UnLockedIcon = MdOutlineVisibilityOff;
